// extracted by mini-css-extract-plugin
export var cell = "_6g-4";
export var headerCell = "_6g-2";
export var rowHeader = "_6g-3";
export var table = "_6g-1";
export var tableContainer = "_6g-0";